import { useCallback } from 'react';
import { useDispatch } from 'react-redux';

import { TEMPORARY_USER_EMAIL } from '@interlayer/js/app/hooks/user/constants';

import { showEmailChangePopup } from 'js/app/components/popups/EmailChangePopup/actions';

export const useVerifyEmailChange = () => {
    const dispatch = useDispatch();

    return useCallback(args => {
        const { email } = args;

        if (email.toLowerCase() === TEMPORARY_USER_EMAIL || email.toLowerCase().includes('@onetogo.co')) {
            dispatch(showEmailChangePopup());
        }

        return args;
    }, [dispatch]);
};
